import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, AlertTitle, IconButton, Box, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { sectionBackgrounds, resolveGradient } from '../../../theme';
/**
 * AlertBanner – important notices and announcements (info, warning, error, success).
 * Supports label + gradient (same as other blocks); props match flow.json structure.
 */
const AlertBanner = ({ label, gradient, severity = 'info', title, message, dismissible = false, titleColor, titleFontSize, messageColor, messageFontSize, backgroundColor, borderRadius = 2, boxShadow, border, borderWidth, borderColor, fontSize, fontFamily, fontWeight = 700, paddingTop, paddingBottom, paddingLeft, paddingRight, marginTop, marginBottom, maxWidth, componentAlignment = 'left', }) => {
    const [visible, setVisible] = useState(true);
    const background = gradient
        ? resolveGradient(gradient, sectionBackgrounds.hero)
        : backgroundColor || 'transparent';
    if (!visible)
        return null;
    return (_jsx(Box, { component: "section", sx: {
            background,
            paddingTop: paddingTop || 2,
            paddingBottom: paddingBottom || 2,
            paddingLeft: paddingLeft || 0,
            paddingRight: paddingRight || 0,
            marginTop: marginTop || 0,
            marginBottom: marginBottom || 0,
            textAlign: componentAlignment,
        }, children: _jsxs(Box, { sx: { maxWidth: maxWidth || 800, mx: 'auto', px: 2 }, children: [label && (_jsx(Typography, { variant: "overline", sx: { display: 'block', mb: 1, color: 'text.secondary', letterSpacing: 1 }, children: label })), _jsxs(Alert, { severity: severity, action: dismissible ? (_jsx(IconButton, { size: "small", onClick: () => setVisible(false), sx: { mt: -0.5 }, "aria-label": "Dismiss", children: _jsx(CloseIcon, { fontSize: "small" }) })) : null, sx: {
                        borderRadius: typeof borderRadius === 'number' ? borderRadius : borderRadius || 2,
                        boxShadow: boxShadow || '0 2px 8px rgba(0,0,0,0.1)',
                        border: border || 'none',
                        borderWidth: borderWidth || undefined,
                        borderColor: borderColor || 'divider',
                        fontFamily: fontFamily || undefined,
                        '& .MuiAlert-icon': { fontSize: '1.5rem' },
                    }, children: [_jsx(AlertTitle, { sx: {
                                fontWeight: Number(fontWeight) || 700,
                                fontSize: titleFontSize || fontSize || '1rem',
                                fontFamily: fontFamily || undefined,
                                color: titleColor || 'inherit',
                            }, children: title || 'Alert' }), _jsx(Typography, { component: "span", sx: {
                                fontSize: messageFontSize || fontSize || '0.875rem',
                                fontFamily: fontFamily || undefined,
                                fontWeight: fontWeight !== undefined ? Number(fontWeight) : undefined,
                                color: messageColor || 'inherit',
                                display: 'block',
                            }, children: message || '' })] })] }) }));
};
export default AlertBanner;
